import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = [{
    quote: "Boardline didn't just find me a role — they repositioned my entire career trajectory. In a market saturated with noise, their team cut through with surgical precision and placed me where I was meant to lead.",
    author: 'M.J., Chief Marketing Officer',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=800&q=80&fit=crop'
  }, {
    quote: 'The caliber of discretion and strategic counsel was extraordinary. Boardline operates at a level of sophistication that most firms simply cannot replicate. They understood the stakes before I had to explain them.',
    author: 'K.R., Managing Director',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80&fit=crop'
  }, {
    quote: "What separates Boardline is their refusal to settle. They didn't present options — they presented the right opportunity. The one that aligned with my values, my ambition, and my legacy. That level of intentionality is rare.",
    author: 'S.L., Senior Vice President',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&q=80&fit=crop'
  }, {
    quote: "I had been quietly miserable in my role for two years but convinced myself it was just the industry. Boardline helped me see that I wasn't burned out — I was in the wrong seat. Six months later, I'm running a division I actually believe in.",
    author: 'D.O., Chief Operating Officer',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&q=80&fit=crop'
  }, {
    quote: "I came to Boardline after being passed over for a promotion I had earned twice. They didn't offer sympathy — they offered strategy. Within 90 days I had three offers, each at a level above where I'd been stuck. I wish I hadn't waited so long.",
    author: 'T.W., Vice President of Finance',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&q=80&fit=crop'
  }, {
    quote: 'Most recruiters see a résumé. Boardline saw a career. They asked questions no one had ever asked me — about what I wanted my work to mean, not just what I wanted to earn. That conversation changed everything about how I approached my search.',
    author: 'R.A., Executive Director, Healthcare',
    image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=800&q=80&fit=crop'
  }];
  return <Section background="navy" className="relative overflow-hidden py-24" data-id="element-447">
      {/* Decorative background blur */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-400/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-448" />

      <FadeIn className="mb-16 text-center relative z-10" data-id="element-449">
        <span className="text-accent-400 text-xs font-bold uppercase tracking-[0.25em] block mb-4" data-id="element-450">
          In Their Words
        </span>
        <h2 className="text-3xl md:text-4xl font-serif text-sage-50 mb-4" data-id="element-451">
          Voices of Distinction
        </h2>
        <div className="h-[1px] w-24 bg-accent-400 mx-auto" data-id="element-452" />
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10 max-w-7xl mx-auto" data-id="element-453">
        {testimonials.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-454">
            <motion.div className="group relative h-full min-h-[420px] overflow-hidden border border-white/10 bg-ink-900" whileHover="hover" initial="initial" data-id="element-455">
              {/* Background Image with Zoom Effect */}
              <motion.div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out" style={{
            backgroundImage: `url(${item.image})`
          }} variants={{
            initial: {
              scale: 1
            },
            hover: {
              scale: 1.05
            }
          }} data-id="element-456" />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900/95 via-ink-900/60 to-ink-900/20" data-id="element-457" />

              {/* Corner Accents */}
              <div className="absolute top-6 left-6 w-6 h-6 border-t border-l border-accent-400/40" data-id="element-458" />
              <div className="absolute top-6 right-6 w-6 h-6 border-t border-r border-accent-400/40" data-id="element-459" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-8 flex flex-col justify-end h-full" data-id="element-460">
                <div className="mb-auto pt-12" data-id="element-461">
                  <Quote className="w-6 h-6 text-accent-400 opacity-60 mb-4" data-id="element-462" />
                </div>

                <p className="text-base text-sage-100 font-serif italic leading-relaxed mb-6 relative z-10" data-id="element-463">
                  "{item.quote}"
                </p>

                <div className="mt-auto" data-id="element-464">
                  <div className="h-[1px] w-10 bg-accent-400/50 mb-3" data-id="element-465" />
                  <p className="text-[10px] uppercase tracking-[0.2em] text-accent-300 font-medium" data-id="element-466">
                    {item.author}
                  </p>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </Section>;
}